import * as React from "react"
import { batch } from "@preact/signals-react";
import { Box, Skeleton, Chip, Grid } from '@mui/material'

import { TitleWithPopover, AppTableSeeker } from "@components";
import {WEBBACK_V2_API} from "@constants";
import {useToast} from "@hooks";
import {
	sponsoredColumn, imageSkuColumn, positionColumn, retailerColumn, skuColumn,
	tagsColumn, keywordColumn, scopeColumn
} from "./columns";
import { useShareOfSearchData } from "./@hooks";
import { showMoreTags, dataDetails, dataDetailsFiltered, filterBrandTitle } from "../../@signals";


export default function ShareOfSearchKeywordTable({ title }) {

	const { isLoading } = useShareOfSearchData()
	const {showToast} = useToast()

	const handleClick = () => batch(() => {
		filterBrandTitle.value = ""
		dataDetails.value = dataDetailsFiltered.value
	})

	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!dataDetails.value.length) return <></>
	
	return <AppTableSeeker
		data={dataDetails.value}
		title={<TitleWithPopover title={title} />}
		forceRender={showMoreTags.value}
		columns={[
			...retailerColumn(),
			imageSkuColumn(),
			...skuColumn(),
			keywordColumn(),
			positionColumn(),
			...sponsoredColumn(),
			...scopeColumn(),
			...tagsColumn()
		]}
		options={{
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/share-of-search/keyword-details/excel`),
			setTableProps: () => ({ sx: {
					".MuiButtonBase-root": {
						fontWeight: 'normal',
					}
				}}),
			customToolbar: () => {
				return <>
					{!!filterBrandTitle.value.length && (
						<Chip label={filterBrandTitle.value} onDelete={handleClick} />
					)}
				</>
			}
		}}
	/>
}